// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1fKFn","name":"Header_name__Zp0-X","birthday":"Header_birthday__1nE75","skeleton":"Header_skeleton__11Jdq"};